<template>
  <Modal :id="id" :title="modalTitle" :hideClose="true">
    <div slot="body" class="modal-body modal-form">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <Field
              type="text"
              name="name"
              label="Category Name"
              v-model="category.name"
              validate="required"
            />
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="modal-footer">
      <a class="btn btn-success" href="#" @click.prevent="save">Save</a>
      <a class="btn btn-secondary" href="#" @click.prevent="close">Cancel</a>
    </div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";
export default {
  mixins: [ModalMixin],
  data() {
    return {
      id: "asset-category-modal",
      category: {
        id: null,
        name: null
      }
    };
  },
  computed: {
    modalTitle() {
      let verb = !!this.category.id ? "Edit" : "Add New";
      return `${verb} Category`;
    }
  },
  methods: {
    save() {
      this.resolve(this.category);
    }
  },
  mounted() {
    this.category = _.clone(this.options.category);
    $(`#${this.id}`).on("shown.bs.modal", function(e) {
      $(".modal-form input").focus();
    });
  }
};
</script>